import { createContext, useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { useLocation, useNavigate } from "react-router-dom";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const publicRoutes = [
      "/", "", "/about", "/whyus", "/faq", "/crypto", "/forex", "/stocks", 
      "/legal", "/policy", "/terms", "/login", "/account", "/register", 
      "/forgot-password", "/reset-password", "/testpage", "/idetails", "/enrollment", "/enrollment1", "/enrollment2", "/enrollment3", "/enrollment4",
    ];
    const checkSession = async (shouldRedirect = false) => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
          credentials: "include",
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ fetchuser: true })
        });
        const data = await response.json();
        if (data.status === "success" && data.user) {
          setUser(data.user);
        } else {
          setUser(null);
          if (shouldRedirect) {
            const currentPath = location.pathname;
            if (!publicRoutes.includes(currentPath) && currentPath !== "/login") {
              navigate("/login");
            }
          }
        }
      } catch (error) {
        console.error("Session check failed:", error);
        setUser(null);
        if (shouldRedirect) {
          const currentPath = location.pathname;
          if (!publicRoutes.includes(currentPath) && currentPath !== "/login") {
            navigate("/login");
          }
        }
      } finally {
        if (shouldRedirect) {
          setLoading(false);
        }
      }
    };
    checkSession(true);
    const interval = setInterval(() => checkSession(false), 30000);
    return () => clearInterval(interval);
  }, [navigate, location.pathname]);



  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);